import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useEffect, useState } from "react";
import { PopUpContainer } from "assets/css/globle";
import CloseIcon from "assets/svgIcons/CloseIcon";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "600px",
  width: "calc(100% -  40px)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  overflow: "hidden",
};

const confirmPopup = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "444px",
  width: "100%",
  bgcolor: "background.paper",
  borderRadius: "5px",
  overflow: "hidden",
};

const VerifyPopup = (props) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={props.open}
      onClose={() => props.SetVerifyPopupOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={props.title == "Missing/Incorrect Data" ? style : confirmPopup}>
        <PopUpContainer
          className={
            props.title == "Missing/Incorrect Data" ? "missing-data-popup" : ""
          }
        >
          <h2
            className={props.title == "Missing/Incorrect Data" ? "header" : ""}
          >
            {props.title}
          </h2>
          <p
            className={
              props.title == "Missing/Incorrect Data"
                ? "missing-data-popup-container"
                : ""
            }
          >
            {props.text}
          </p>

          <div className="action-btn">
            <button
              className="primary"
              onClick={() => {
                props.SetVerifyPopupOpen(false);
                props.setVerifyTitle("");
              }}
            >
              {t("Ok")}
            </button>
          </div>
        </PopUpContainer>
      </Box>
    </Modal>
  );
};

export default VerifyPopup;
